export default {
  Register: 'Register License',
  Licenses: 'Licenses',
  Request: 'Requests',
  Dashboard: 'Dashboard',
  Settings: 'Manage Accounts',
  Logout: 'Logout',
  Tickets: 'Tickets',
  ChangePassword: 'Change Password',
  Partner: 'Partner',
};